
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as passwordjzd3uYCT7FMeta } from "/frontend/pages/account/password.vue?macro=true";
import { default as indexyFUmTDp4hAMeta } from "/frontend/pages/admin/ai-models/index.vue?macro=true";
import { default as indexxhQsZq8LAmMeta } from "/frontend/pages/admin/billing/index.vue?macro=true";
import { default as indexGKsm1wTRIKMeta } from "/frontend/pages/admin/chat/index.vue?macro=true";
import { default as indexGNLR7Emid5Meta } from "/frontend/pages/admin/claude-code/index.vue?macro=true";
import { default as index070TdbQSd6Meta } from "/frontend/pages/admin/colors/index.vue?macro=true";
import { default as indexB6ZTsKQCpvMeta } from "/frontend/pages/admin/cookie-consent/index.vue?macro=true";
import { default as _91key_93CEWiw7V0PSMeta } from "/frontend/pages/admin/data/[key].vue?macro=true";
import { default as indexEyF14Iz3UzMeta } from "/frontend/pages/admin/data/index.vue?macro=true";
import { default as indexhmaZYWTjAwMeta } from "/frontend/pages/admin/domains/index.vue?macro=true";
import { default as indexVPwz0NgbCDMeta } from "/frontend/pages/admin/feedback/index.vue?macro=true";
import { default as indexyYeCF0pdgeMeta } from "/frontend/pages/admin/free-domains/index.vue?macro=true";
import { default as indexNO4zRMpg1uMeta } from "/frontend/pages/admin/history/index.vue?macro=true";
import { default as indexyqcIVOQf4qMeta } from "/frontend/pages/admin/icons/index.vue?macro=true";
import { default as indexBSZCR0l6p3Meta } from "/frontend/pages/admin/invoice-templates/index.vue?macro=true";
import { default as _91id_93qnzvWR2U1RMeta } from "/frontend/pages/admin/leads/[id].vue?macro=true";
import { default as indexlGpRNZTgnLMeta } from "/frontend/pages/admin/leads/index.vue?macro=true";
import { default as indexcX9UtssOeXMeta } from "/frontend/pages/admin/locales/index.vue?macro=true";
import { default as maintenanceIx57oTvspQMeta } from "/frontend/pages/admin/maintenance.vue?macro=true";
import { default as indexdMIeld7sizMeta } from "/frontend/pages/admin/oversight/index.vue?macro=true";
import { default as indexckIdF9nkjtMeta } from "/frontend/pages/admin/requests/index.vue?macro=true";
import { default as indexnIWqacnPmtMeta } from "/frontend/pages/admin/snippet-types/index.vue?macro=true";
import { default as indexs9jrczye1bMeta } from "/frontend/pages/admin/templates/index.vue?macro=true";
import { default as indexqKEBJzNDmHMeta } from "/frontend/pages/admin/users/index.vue?macro=true";
import { default as indexd6XkqdptEoMeta } from "/frontend/pages/admin/webs/index.vue?macro=true";
import { default as login2h9QrUJTKfMeta } from "/frontend/pages/auth/login.vue?macro=true";
import { default as registerZWcQHPlMtNMeta } from "/frontend/pages/auth/register.vue?macro=true";
import { default as indexha9JU2U4bvMeta } from "/frontend/pages/chat/index.vue?macro=true";
import { default as indexVMzdOGaxrYMeta } from "/frontend/pages/contact/index.vue?macro=true";
import { default as _91token_93A40xKbT41hMeta } from "/frontend/pages/d/[token].vue?macro=true";
import { default as demobSIDJ0xWHTMeta } from "/frontend/pages/demo.vue?macro=true";
import { default as index2m300ZxsqLMeta } from "/frontend/pages/domains/index.vue?macro=true";
import { default as indexaT45PWK5MiMeta } from "/frontend/pages/firma/index.vue?macro=true";
import { default as indexzh70oVUhJfMeta } from "/frontend/pages/index.vue?macro=true";
import { default as indexMzUddHZ5mLMeta } from "/frontend/pages/invite/index.vue?macro=true";
import { default as indexRMY5QbvRTAMeta } from "/frontend/pages/invoices/index.vue?macro=true";
import { default as index1KSnYeDPPUMeta } from "/frontend/pages/media/index.vue?macro=true";
import { default as indexLdXbmvRUDmMeta } from "/frontend/pages/members/index.vue?macro=true";
import { default as index1y69a2rTRyMeta } from "/frontend/pages/pages/index.vue?macro=true";
import { default as index3dfkKLNLfdMeta } from "/frontend/pages/podminky/index.vue?macro=true";
import { default as osobni_45udajebbjZDzQLq2Meta } from "/frontend/pages/podminky/osobni-udaje.vue?macro=true";
import { default as zpracovatelska_45smlouvaNQ5teNtFVRMeta } from "/frontend/pages/podminky/zpracovatelska-smlouva.vue?macro=true";
import { default as indexIfzCWjdl2zMeta } from "/frontend/pages/seo/index.vue?macro=true";
import { default as _91slug_93enYAkLaxGIMeta } from "/frontend/pages/snippets/[slug].vue?macro=true";
import { default as indexBPWSCNxgyyMeta } from "/frontend/pages/statistics/index.vue?macro=true";
import { default as _91id_93YahatAIIEAMeta } from "/frontend/pages/template-edit/[id].vue?macro=true";
import { default as indexykrf6wojAjMeta } from "/frontend/pages/template-edit/index.vue?macro=true";
import { default as indexGQEqs8H9C5Meta } from "/frontend/pages/verify-email/index.vue?macro=true";
import { default as _91id_93S0kt1eA72WMeta } from "/frontend/pages/web-code/[id].vue?macro=true";
import { default as indexmel7PUmkyDMeta } from "/frontend/pages/web-edit/index.vue?macro=true";
import { default as indexpcobZR64t0Meta } from "/frontend/pages/web-history/index.vue?macro=true";
import { default as zavolali_45jsme6rITCSuAreMeta } from "/frontend/pages/zavolali-jsme.vue?macro=true";
export default [
  {
    name: "account-password",
    path: "/account/password",
    meta: passwordjzd3uYCT7FMeta || {},
    component: () => import("/frontend/pages/account/password.vue")
  },
  {
    name: "admin-ai-models",
    path: "/admin/ai-models",
    meta: indexyFUmTDp4hAMeta || {},
    component: () => import("/frontend/pages/admin/ai-models/index.vue")
  },
  {
    name: "admin-billing",
    path: "/admin/billing",
    meta: indexxhQsZq8LAmMeta || {},
    component: () => import("/frontend/pages/admin/billing/index.vue")
  },
  {
    name: "admin-chat",
    path: "/admin/chat",
    meta: indexGKsm1wTRIKMeta || {},
    component: () => import("/frontend/pages/admin/chat/index.vue")
  },
  {
    name: "admin-claude-code",
    path: "/admin/claude-code",
    meta: indexGNLR7Emid5Meta || {},
    component: () => import("/frontend/pages/admin/claude-code/index.vue")
  },
  {
    name: "admin-colors",
    path: "/admin/colors",
    meta: index070TdbQSd6Meta || {},
    component: () => import("/frontend/pages/admin/colors/index.vue")
  },
  {
    name: "admin-cookie-consent",
    path: "/admin/cookie-consent",
    meta: indexB6ZTsKQCpvMeta || {},
    component: () => import("/frontend/pages/admin/cookie-consent/index.vue")
  },
  {
    name: "admin-data-key",
    path: "/admin/data/:key()",
    meta: _91key_93CEWiw7V0PSMeta || {},
    component: () => import("/frontend/pages/admin/data/[key].vue")
  },
  {
    name: "admin-data",
    path: "/admin/data",
    meta: indexEyF14Iz3UzMeta || {},
    component: () => import("/frontend/pages/admin/data/index.vue")
  },
  {
    name: "admin-domains",
    path: "/admin/domains",
    meta: indexhmaZYWTjAwMeta || {},
    component: () => import("/frontend/pages/admin/domains/index.vue")
  },
  {
    name: "admin-feedback",
    path: "/admin/feedback",
    meta: indexVPwz0NgbCDMeta || {},
    component: () => import("/frontend/pages/admin/feedback/index.vue")
  },
  {
    name: "admin-free-domains",
    path: "/admin/free-domains",
    meta: indexyYeCF0pdgeMeta || {},
    component: () => import("/frontend/pages/admin/free-domains/index.vue")
  },
  {
    name: "admin-history",
    path: "/admin/history",
    meta: indexNO4zRMpg1uMeta || {},
    component: () => import("/frontend/pages/admin/history/index.vue")
  },
  {
    name: "admin-icons",
    path: "/admin/icons",
    meta: indexyqcIVOQf4qMeta || {},
    component: () => import("/frontend/pages/admin/icons/index.vue")
  },
  {
    name: "admin-invoice-templates",
    path: "/admin/invoice-templates",
    meta: indexBSZCR0l6p3Meta || {},
    component: () => import("/frontend/pages/admin/invoice-templates/index.vue")
  },
  {
    name: "admin-leads-id",
    path: "/admin/leads/:id()",
    meta: _91id_93qnzvWR2U1RMeta || {},
    component: () => import("/frontend/pages/admin/leads/[id].vue")
  },
  {
    name: "admin-leads",
    path: "/admin/leads",
    meta: indexlGpRNZTgnLMeta || {},
    component: () => import("/frontend/pages/admin/leads/index.vue")
  },
  {
    name: "admin-locales",
    path: "/admin/locales",
    meta: indexcX9UtssOeXMeta || {},
    component: () => import("/frontend/pages/admin/locales/index.vue")
  },
  {
    name: "admin-maintenance",
    path: "/admin/maintenance",
    meta: maintenanceIx57oTvspQMeta || {},
    component: () => import("/frontend/pages/admin/maintenance.vue")
  },
  {
    name: "admin-oversight",
    path: "/admin/oversight",
    meta: indexdMIeld7sizMeta || {},
    component: () => import("/frontend/pages/admin/oversight/index.vue")
  },
  {
    name: "admin-requests",
    path: "/admin/requests",
    meta: indexckIdF9nkjtMeta || {},
    component: () => import("/frontend/pages/admin/requests/index.vue")
  },
  {
    name: "admin-snippet-types",
    path: "/admin/snippet-types",
    meta: indexnIWqacnPmtMeta || {},
    component: () => import("/frontend/pages/admin/snippet-types/index.vue")
  },
  {
    name: "admin-templates",
    path: "/admin/templates",
    meta: indexs9jrczye1bMeta || {},
    component: () => import("/frontend/pages/admin/templates/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: indexqKEBJzNDmHMeta || {},
    component: () => import("/frontend/pages/admin/users/index.vue")
  },
  {
    name: "admin-webs",
    path: "/admin/webs",
    meta: indexd6XkqdptEoMeta || {},
    component: () => import("/frontend/pages/admin/webs/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: login2h9QrUJTKfMeta || {},
    component: () => import("/frontend/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerZWcQHPlMtNMeta || {},
    component: () => import("/frontend/pages/auth/register.vue")
  },
  {
    name: "chat",
    path: "/chat",
    meta: indexha9JU2U4bvMeta || {},
    component: () => import("/frontend/pages/chat/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexVMzdOGaxrYMeta || {},
    component: () => import("/frontend/pages/contact/index.vue")
  },
  {
    name: "d-token",
    path: "/d/:token()",
    meta: _91token_93A40xKbT41hMeta || {},
    component: () => import("/frontend/pages/d/[token].vue")
  },
  {
    name: "demo",
    path: "/demo",
    meta: demobSIDJ0xWHTMeta || {},
    component: () => import("/frontend/pages/demo.vue")
  },
  {
    name: "domains",
    path: "/domains",
    meta: index2m300ZxsqLMeta || {},
    component: () => import("/frontend/pages/domains/index.vue")
  },
  {
    name: "firma",
    path: "/firma",
    meta: indexaT45PWK5MiMeta || {},
    component: () => import("/frontend/pages/firma/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexzh70oVUhJfMeta || {},
    component: () => import("/frontend/pages/index.vue")
  },
  {
    name: "invite",
    path: "/invite",
    meta: indexMzUddHZ5mLMeta || {},
    component: () => import("/frontend/pages/invite/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexRMY5QbvRTAMeta || {},
    component: () => import("/frontend/pages/invoices/index.vue")
  },
  {
    name: "media",
    path: "/media",
    meta: index1KSnYeDPPUMeta || {},
    component: () => import("/frontend/pages/media/index.vue")
  },
  {
    name: "members",
    path: "/members",
    meta: indexLdXbmvRUDmMeta || {},
    component: () => import("/frontend/pages/members/index.vue")
  },
  {
    name: "pages",
    path: "/pages",
    meta: index1y69a2rTRyMeta || {},
    component: () => import("/frontend/pages/pages/index.vue")
  },
  {
    name: "podminky",
    path: "/podminky",
    meta: index3dfkKLNLfdMeta || {},
    component: () => import("/frontend/pages/podminky/index.vue")
  },
  {
    name: "podminky-osobni-udaje",
    path: "/podminky/osobni-udaje",
    meta: osobni_45udajebbjZDzQLq2Meta || {},
    component: () => import("/frontend/pages/podminky/osobni-udaje.vue")
  },
  {
    name: "podminky-zpracovatelska-smlouva",
    path: "/podminky/zpracovatelska-smlouva",
    meta: zpracovatelska_45smlouvaNQ5teNtFVRMeta || {},
    component: () => import("/frontend/pages/podminky/zpracovatelska-smlouva.vue")
  },
  {
    name: "seo",
    path: "/seo",
    meta: indexIfzCWjdl2zMeta || {},
    component: () => import("/frontend/pages/seo/index.vue")
  },
  {
    name: "snippets-slug",
    path: "/snippets/:slug()",
    meta: _91slug_93enYAkLaxGIMeta || {},
    component: () => import("/frontend/pages/snippets/[slug].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexBPWSCNxgyyMeta || {},
    component: () => import("/frontend/pages/statistics/index.vue")
  },
  {
    name: "template-edit-id",
    path: "/template-edit/:id()",
    meta: _91id_93YahatAIIEAMeta || {},
    component: () => import("/frontend/pages/template-edit/[id].vue")
  },
  {
    name: "template-edit",
    path: "/template-edit",
    meta: indexykrf6wojAjMeta || {},
    component: () => import("/frontend/pages/template-edit/index.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: indexGQEqs8H9C5Meta || {},
    component: () => import("/frontend/pages/verify-email/index.vue")
  },
  {
    name: "web-code-id",
    path: "/web-code/:id()",
    meta: _91id_93S0kt1eA72WMeta || {},
    component: () => import("/frontend/pages/web-code/[id].vue")
  },
  {
    name: "web-edit",
    path: "/web-edit",
    meta: indexmel7PUmkyDMeta || {},
    component: () => import("/frontend/pages/web-edit/index.vue")
  },
  {
    name: "web-history",
    path: "/web-history",
    meta: indexpcobZR64t0Meta || {},
    component: () => import("/frontend/pages/web-history/index.vue")
  },
  {
    name: "zavolali-jsme",
    path: "/zavolali-jsme",
    meta: zavolali_45jsme6rITCSuAreMeta || {},
    component: () => import("/frontend/pages/zavolali-jsme.vue")
  }
]